<motif-modal-content>
  <p>Are you sure you want to stop attribute extraction?</p>
  <motif-modal-actions class="popupButton">
    <div class="confirm-button">
      <button motifButton class="cra-button button-light" [motif-modal-close]="true">Stop</button>
    </div>
    <div class="cancel-button">
      <button motifButton class="cra-button button-dark" [motif-modal-close]="false">Cancel</button>
    </div>
  </motif-modal-actions>
</motif-modal-content>
